import { render, staticRenderFns } from "./TransactionActiveBadge.vue?vue&type=template&id=33d11c66&scoped=true&"
import script from "./TransactionActiveBadge.vue?vue&type=script&lang=js&"
export * from "./TransactionActiveBadge.vue?vue&type=script&lang=js&"
import style0 from "./TransactionActiveBadge.vue?vue&type=style&index=0&id=33d11c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d11c66",
  null
  
)

export default component.exports